document.addEventListener('DOMContentLoaded', () => {
    const popup = document.getElementById('stories-popup');
    const closePopup = popup.querySelector('.popup-close');
    let mainSwiper = null;
    let isMuted = true;

    const handleVideoPlayback = async (slide, isActive) => {
        const video = slide.querySelector('video');
        if (!video) return;

        try {
            // Set muted state
            video.muted = isMuted;

            if (isActive) {
                video.currentTime = 0;
                video.play();
            } else {
                video.pause();
                video.currentTime = 0;
            }
        } catch (err) {
            console.error('Video playback error:', err);
        }
    };

    const handleNestedSwiperAutoplay = (nestedSwiper, isActive) => {
        if (!nestedSwiper.swiper) return;

        // Stop all videos first
        nestedSwiper.swiper.slides.forEach(slide => handleVideoPlayback(slide, false));

        if (isActive) {
            nestedSwiper.swiper.slideTo(0);
            handleVideoPlayback(nestedSwiper.swiper.slides[0], true);
            nestedSwiper.swiper.autoplay.start();
        } else {
            nestedSwiper.swiper.autoplay.stop();
        }
    };

    const initializeNestedSwiper = (nestedSwiperElement) => {
        if (nestedSwiperElement.swiper) return;

        let isManualSlideChange = false;

        return new Swiper(nestedSwiperElement, {
            loop: false,
            speed: 0,
            spaceBetween: 80,
            navigation: {
                nextEl: '.nested-button-next',
                prevEl: '.nested-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoplay: {
                delay: 2500,
                stopOnLastSlide: true,
                disableOnInteraction: false,
            },
            slidesPerView: 1,
            on: {
                init: function (swiper) {
                    const activeBullet = swiper.pagination.bullets[swiper.realIndex];
                    if (activeBullet) {
                        activeBullet.style.width = '0%';
                    }
                },
                slideChange: function (swiper) {
                    // Handle video playback
                    swiper.slides.forEach((slide, i) => {
                        handleVideoPlayback(slide, i === swiper.activeIndex);
                    });

                    // Reset all bullets progress
                    swiper.pagination.bullets.forEach(bullet => {
                        bullet.style.width = '0%';
                        bullet.style.transition = 'none';
                        bullet.style.setProperty('--progress', '0%');  // Reset progress for all bullets
                    });

                    // Start progress animation for current bullet
                    const currentBullet = swiper.pagination.bullets[swiper.realIndex];
                    const currentSlide = swiper.slides[swiper.activeIndex];
                    const video = currentSlide.querySelector('video');
                    const duration = video ? video.duration * 1000 : 2500;

                    if (currentBullet) {
                        currentBullet.style.width = '0%';
                        setTimeout(() => {
                            currentBullet.style.transition = `width ${duration}ms linear`;
                            currentBullet.style.width = '100%';
                        }, 0);
                    }

                    // Mark previous bullets as completed
                    swiper.pagination.bullets.forEach((bullet, index) => {
                        if (index < swiper.realIndex) {
                            bullet.classList.add('completed');
                        } else {
                            bullet.classList.remove('completed');
                        }
                    });

                    // Reset and restart autoplay
                    swiper.autoplay.stop();
                    setTimeout(() => {
                        swiper.autoplay.start();
                    }, 0);

                    // Calculate remaining time for main swiper
                    if (mainSwiper) {
                        const remainingSlides = swiper.slides.slice(swiper.activeIndex);
                        const remainingTime = remainingSlides.reduce((total, slide) => {
                            const video = slide.querySelector('video');
                            return total + (video ? video.duration * 1000 : 2500);
                        }, 0);

                        mainSwiper.params.autoplay.delay = remainingTime;
                        mainSwiper.autoplay.stop();
                        mainSwiper.autoplay.start();
                    }

                    if (swiper.isEnd && !isManualSlideChange) {
                        const lastSlideVideo = swiper.slides[swiper.activeIndex].querySelector('video');
                        const lastSlideDuration = lastSlideVideo ? lastSlideVideo.duration * 1000 : 2500;

                        setTimeout(() => {
                            if (mainSwiper && swiper.isEnd) {
                                mainSwiper.slideNext();
                            }
                        }, lastSlideDuration);
                    }

                    isManualSlideChange = false;
                },
                touchStart: function () {
                    isManualSlideChange = true;
                },
                reachEnd: function () {
                    // Do nothing on manual reach end
                },
                autoplayTimeLeft: function (swiper, time, progress) {
                    swiper.pagination.bullets.forEach((bullet, index) => {
                        if (index === swiper.realIndex) {
                            bullet.style.setProperty('--progress', `${(1 - progress) * 100}%`);
                        } else {
                            bullet.style.setProperty('--progress', '0%');  // Reset progress for inactive bullets
                        }
                    });
                }
            }
        });
    };

    const initializeMainSwiper = (initialSlide = 0) => {
        mainSwiper = new Swiper('.main-swiper', {
            initialSlide,
            spaceBetween: 130,
            navigation: {
                nextEl: '.main-button-next',
                prevEl: '.main-button-prev',
            },
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            slidesPerView: 1,
            on: {
                init: function (swiper) {
                    swiper.slides.forEach((slide, i) => {
                        const isActive = i === swiper.activeIndex;
                        slide.querySelectorAll('.nested-swiper').forEach(nestedSwiper => {
                            initializeNestedSwiper(nestedSwiper);
                            handleNestedSwiperAutoplay(nestedSwiper, isActive);
                        });
                        handleVideoPlayback(slide, isActive);
                    });
                },
                slideChange: function (swiper) {
                    swiper.slides.forEach((slide, i) => {
                        const isActive = i === swiper.activeIndex;
                        slide.querySelectorAll('.nested-swiper').forEach(nestedSwiper => {
                            handleNestedSwiperAutoplay(nestedSwiper, isActive);
                        });
                        handleVideoPlayback(slide, isActive);
                    });
                }
            }
        });
    };

    const openPopup = (index) => {
        popup.style.display = 'flex';
        document.body.classList.add('stories_popup_open');

        if (!mainSwiper) {
            initializeMainSwiper(index);
        } else {
            mainSwiper.slideToLoop(index);
            mainSwiper.slides.forEach((slide, i) => {
                const isActive = i === mainSwiper.activeIndex;
                slide.querySelectorAll('.nested-swiper').forEach(nestedSwiper => {
                    handleNestedSwiperAutoplay(nestedSwiper, isActive);
                });
                handleVideoPlayback(slide, isActive);
            });
        }
    };

    function initializeCloseButtons() {
        // Get the popup element
        const popup = document.getElementById('stories-popup');

        // Add click event listeners to all close buttons
        document.querySelectorAll('.popup-close').forEach(button => {
            button.addEventListener('click', (e) => {
                e.stopPropagation();
                handlePopupClose();
            });
        });

        // Also close when clicking outside the story content
        popup.addEventListener('click', (e) => {
            if (e.target === popup) {
                handlePopupClose();
            }
        });

        // Add escape key listener
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                handlePopupClose();
            }
        });
    }

    function handlePopupClose() {
        const popup = document.getElementById('stories-popup');
        popup.style.display = 'none';
        document.body.classList.remove('stories_popup_open');

        // Pause all videos when closing
        document.querySelectorAll('.popup-video').forEach(video => {
            video.pause();
        });

        if (mainSwiper) {
            mainSwiper.slides.forEach(slide => {
                slide.querySelectorAll('.nested-swiper').forEach(nestedSwiper => {
                    if (nestedSwiper.swiper) {
                        nestedSwiper.swiper.destroy();
                    }
                });
            });
            mainSwiper.destroy();
            mainSwiper = null;
        }
    }

    // Add new function to handle mute toggle
    const toggleMute = () => {
        isMuted = !isMuted;

        // Update all active videos
        document.querySelectorAll('.popup-video').forEach(video => {
            video.muted = isMuted;
        });

        // Update mute button appearance - for two separate SVGs
        document.querySelectorAll('.mute-button').forEach(button => {
            const soundWaveIcon = button.querySelector('.sound-wave');
            const mutedIcon = button.querySelector('svg:not(.sound-wave)');

            if (isMuted) {
                soundWaveIcon.style.display = 'none';
                mutedIcon.style.display = 'block';
            } else {
                soundWaveIcon.style.display = 'block';
                mutedIcon.style.display = 'none';
            }
        });
    };

    // Add to your initialization code
    function initializeControls() {
        initializeCloseButtons();

        // Initialize mute buttons
        document.querySelectorAll('.mute-button').forEach(button => {
            button.addEventListener('click', (e) => {
                e.stopPropagation();
                toggleMute();
            });

            // Set initial state for two SVGs
            const soundWaveIcon = button.querySelector('.sound-wave');
            const mutedIcon = button.querySelector('svg:not(.sound-wave)');

            // Start muted
            soundWaveIcon.style.display = 'none';
            mutedIcon.style.display = 'block';
        });
    }

    // Replace the initializeCloseButtons() call with initializeControls()
    initializeControls();

    // Event Handlers
    const popupClickHandler = (e) => {
        if (e.target === popup) handlePopupClose();
    };

    const keyboardHandler = (e) => {
        if (!mainSwiper || popup.style.display !== 'flex') return;

        switch (e.key) {
            case 'ArrowRight':
                mainSwiper.slideNext();
                break;
            case 'ArrowLeft':
                mainSwiper.slidePrev();
                break;
            case 'Escape':
                handlePopupClose();
                break;
        }
    };

    // Event Listeners
    document.querySelectorAll('.story-item').forEach((item, index) => {
        item.addEventListener('click', () => openPopup(index));
    });

    closePopup.addEventListener('click', handlePopupClose);
    popup.addEventListener('click', popupClickHandler);
    document.addEventListener('keydown', keyboardHandler);
});
